module.exports = __webpack_public_path__ + "img/pic21.ab59f70b.png";